import {EmailTemplateModel} from '../../model'
export const initValues: EmailTemplateModel = {
  id: '',
  nombre: '',
  aplicacionId: '',
  aplicacion: '',
  envioCustomizado: '',
  de: '',
  nombreEstado: '',
  para: '',
  asunto: '',
  conCopia: '',
  conCopiaOculta: '',
  mensaje: '',
  tabla: '',
  idColumna: '',
  estado: '',
  observaciones: '',
}
